import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { css } from 'styled-components'

export const setGridStyle = ({ columns }: { columns: number }) => {
  return css` 
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: repeat(${columns}, 75%);
    row-gap: ${rem(24)};
    column-gap: ${rem(16)};
    grid-auto-flow: column;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

    ${mediaQueryUp.sm} {
      grid-template-columns: repeat(${columns}, 40%);
    }

    ${mediaQueryUp.lg} {
      grid-template-columns: repeat(${columns}, 1fr);
    }
  `
}
